import axios from "axios";
import { environment } from "../../environment";

export const AuthService = () => {

    const validateEmail = async (email: string): Promise<any> => {
        try {
            const res = await axios.get(environment.authUrl + 'auth/verify/' + email);
            if (res?.data && res.data.emailValid === true) {
                return true;
            } else {
                return false;
            }
        } catch (err) {
            throw err
        }
    }

    const loginUser = async (username: string, password: string) => {
        try {
            const res = await axios.post(environment.authUrl + 'auth/loginUser', {
                email: username,
                password
            })
            if (res && res.data && res.data.userAuth) {
                return res.data;
            } else {
                throw new Error('Login was not successful with the provided credentials')
            }
        } catch (err) {
            throw err
        }
    }

    const loginWithOtp = async (username: string, password: string, otp: string) => {
        try {
            const res = await axios.post(environment.authUrl + 'auth/loginWithOtp', {
                email: username,
                password,
                otp
            })
            if (res && res.data && res.data.access_token) {
                return res.data;
            } else {
                throw new Error('Login was not successful with the provided code')
            }
        } catch (err) {
            throw err
        }
    }

    const login = async (username: string, password: string) => {
        try {
            const res = await axios.post(environment.authUrl + 'auth/login', {
                email: username,
                password
            })
            if (res && res.data && res.data.access_token) {
                return res.data;
            } else {
                return { error: 'Login was not successful with the provided credentials'}
            }
        } catch (err) {
            throw err
        }
    }

    const logout = () => {
        try {
            localStorage.removeItem('token');
        } catch (err) {
            throw err
        }
    }

    return {
        loginUser,
        validateEmail,
        loginWithOtp,
        logout,
        login
    }
}




